import { gateway } from "../../../../gateway";

export const deleteJobAction = async (jobId: string): Promise<void> => {
    try {
        if (!jobId) throw new Error("Job ID is required.");

        await gateway.delete(`/jobs/self/${jobId}`)

    } catch (error: any) {
        console.error('Error deleting job', error);
        const errorMessage = error?.response?.data?.message || error?.message || 'Failed to delete job';
        throw new Error(errorMessage);
    }
}